export default "__VITE_ASSET__5432395f__"